<template>
  <div class="newsInformation">
    <detailsTop :topIndex="topIndex" @bannerIndexClick="bannerIndexClick" />
    <div class="news-content">
      <div class="new-left"></div>
      <div class="new-center">
        <bannerTips
          :bannerTipsList="bannerTipsList"
          @changeTips="changeTips"
          :bannerIndex="bannerIndex"
        />

        <div class="content">
          <div class="newList-wrap">
            <div
              style="cursor: pointer"
              v-for="(item, index) in newList"
              :key="index"
              class="new-list"
            >
              <div @click="jumpPage(item)">
                <el-image
                  lazy
                  class="newList-wrap-left"
                  :src="baseURL + item.cover"
                >
                  <div slot="placeholder" class="image-slot">
                    加载中<span class="dot">...</span>
                  </div>
                </el-image>
                <p class="item-title">{{ item.title }}</p>
              </div>
            </div>
          </div>

          <!-- <div class="text" v-html="newInfo.content"></div>  -->
        </div>

        <!-- <div class="pagination">
          <el-pagination
            background
            @current-change="handleCurrentChange"
            prev-text="上一页"
            next-text="下一页"
            :current-page.sync="page"
            :page-size="size"
            layout="prev, pager, next, jumper"
            :total="total"
          >
          </el-pagination>
        </div> -->
      </div>
      <div class="new-right"></div>
    </div>

    <pageBottom />
  </div>
</template>

<script>
import detailsTop from "@/components/detailsTop.vue";
import pageBottom from "@/components/pageBottom";
import bannerTips from "@/components/bannerTips";
import { selectTNewsPage,getTNewsInfo,selectTPartnerPage} from "@/api/api.js";

export default {
  name: "news1",
  components: {
    detailsTop,
    pageBottom,
    bannerTips,
  },
  data() {
    return {
      bannerTipsList: [],
      topIndex: null,
      bannerIndex: 0,
      page: 1,
      size: 6,
      total: null,
      newList: [],
      newInfo: {},
    };
  },
  created() {
    this.topIndex = this.$route.query.topIndex;
    this.bannerTipsList = JSON.parse(localStorage.getItem("bannerList"));
    this.bannerIndex = Number(localStorage.getItem("lobannerIndex"));
    this.getData();
  },
  mounted() {
    const that = this;
    window.addEventListener("setItemEvent", function (e) {
      if (e.key === "lobannerIndex") {
        // myKey是需要监听的键名
        that.lobannerIndex = e.newValue;
        that.bannerIndex = e.newValue;
        that.getData();
      }
    });
  },
  methods: {
    bannerIndexClick(index) {
      // this.bannerIndex = index
    },
    changeTips(index) {
      this.bannerIndex = index;
      this.getData();
    },
    async getData() {
      var params = {
        page: this.page,
        size: this.size,
        projectTypeParentId: this.bannerTipsList[this.bannerIndex]?.parentId,
        projectTypeSubId: this.bannerTipsList[this.bannerIndex]?.projectTypeId,
      };
      const { data } = await selectTNewsPage(params);
      if (data.code === 200) {
        this.newList = data.data.list;
        this.total = data.data.total;
      }
      // let newsId = this.newList[0].newsId;
      // let projectTypeParentId = this.newList[0].projectTypeParentId;
      // this.getNewInfo(newsId, projectTypeParentId);
    },
    //获取到文章详情
    async getNewInfo(newsId, projectTypeParentId) {
      const { data } = await getTNewsInfo({
        newsId: newsId,
        projectTypeParentId: projectTypeParentId,
      });
      this.newInfo = data.data;
    },
    jumpPage(item) {
      const routeUrl = this.$router.resolve({
        path: "/newDetails",
        query: {
          newsId: item.newsId,
          projectTypeParentId: item.projectTypeParentId,
          topIndex: this.topIndex,
        },
      });
      window.open(routeUrl.href, "_blank");
    },

    handleCurrentChange(val) {
      this.page = val;
      this.getData();
    },
  },
};
</script>

<style scoped lang="less">
* {
  padding: 0;
  margin: 0;
}
.news-content {
  width: 86%;
  max-width: 1440px;
  margin: 20px auto;
  height: 100%;

  .new-center {
    background: #f4f4f4;

    .content {
      width: 100%;
      margin-top: 22px;
      // background: #ffffff;
      padding-top: 2%;

      .newList-wrap {
        width: 100%;
        display: flex;
        flex-wrap: wrap;

        .new-list {
          width: 32%;
          margin-bottom: 2%;
          margin-right: 2%;
          background: #fff;

          .newList-wrap-left {
            width: 100%;
            height: 260px;
          }

          .item-title {
            text-align: left;
            width: 86%;
            display: block;
            margin-left: 30px;
            padding: 0px;
            margin-top: 10px;
            font-size: 14px;
            color: #333;
            line-height: 24px;
            padding-bottom: 10px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
        }

        .new-list:nth-child(3n) {
          margin-right: 0;
        }
      }
    }

    .pagination {
      margin: 4% auto;
    }
  }

  .new-right {
    flex: 1;
    // background: sandybrown;
  }
  ::v-deep .el-pagination.is-background .el-pager li:not(.disabled).active {
    background-color: #46739f;
    color: #fff;
  }
}

@media only screen and (max-width: 1550px) {
  .new-left {
    flex: 1 !important;
  }

  .new-center {
    flex: 12 !important;
    background: #f4f4f4;
  }

  .new-right {
    flex: 1 !important;
  }
}
</style>
